<template>
    <div class="row">
        <div class="col-12">
            <div class="new-button-div">
                <n-button @click.native="savePDF()" type="primary" round>
                <i slot="label" class="now-ui-icons files_paper"></i>
                {{ $t("app.buttons.pdf") }}
                </n-button>
            </div>
            <card card-body-classes="table-full-width" no-footer-line>
                <h4 slot="header" class="card-title text-purple">
                {{ $t("app.modules.account_statements.name") }}
                </h4>
                <div class="col-md-12">
                    <div class="row">
                        <el-table stripe style="width: 100%" :data="account">
                            <el-table-column
                            prop="idClienteSAP"
                            :label="this.$t('app.modules.customers.client_code_SAP')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="facturaFiscal"
                            :label="this.$t('app.modules.account_statements.headers.fiscal_bill')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="facturaComercial"
                            :label="this.$t('app.modules.account_statements.headers.commercial_bill')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="fechaFaturacion"
                            :label="this.$t('app.modules.account_statements.headers.bill_date')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="moneda"
                            :label="this.$t('app.modules.account_statements.headers.money')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="monto"
                            :label="this.$t('app.modules.account_statements.headers.amount')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="terminosPago"
                            :label="this.$t('app.modules.account_statements.headers.payment_terms')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="vencimiento"
                            :label="this.$t('app.modules.account_statements.headers.expire_date')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    components: {}, 
    data(){
        return{
            item: {}, 
            account: {}
        }
    }, 
    async mounted(){
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });
        this.item = this.$route.params
        await this.getAccount(this.item.idClienteSAP)
        this.$swal.close();
    }, 
    methods:{
        async getAccount(id){
            var payload = {
                id: id,
                claveIdioma: this.$store.state.lang, 
                usuario: 1
            };

            await this.$http
            .post(route("EstadoCuenta/processEstadosCuenta"), payload)
            .then(
                async response => {
                    if (response.body.code === 200){
                        this.account = response.body.estadosCuenta
                    }
                    else {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            )
            .finally(() => {});
        }, 
        async savePDF(){
                this.$swal.fire({
                title: this.$t("app.promps.wait"),
                html:
                    '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                showConfirmButton: false
                });

                var payload = {
                    id: this.item.idClienteSAP, 
                    claveIdioma: this.$store.state.lang, 
                    usuario: 1, 
                    direccionFiscal: this.$t('app.modules.account_statements.headers.fiscal_address'),
                    idClienteSAP: this.$t('app.modules.account_statements.headers.client_id'),
                    facturaFiscal: this.$t('app.modules.account_statements.headers.fiscal_bill'),
                    facturaComercial: this.$t('app.modules.account_statements.headers.commercial_bill'),
                    fechaFaturacion: this.$t('app.modules.account_statements.headers.bill_date'),
                    moneda: this.$t('app.modules.account_statements.headers.money'),
                    monto: this.$t('app.modules.account_statements.headers.amount'),
                    terminosPago: this.$t('app.modules.account_statements.headers.payment_terms'),
                    fechaVencimiento: this.$t('app.modules.account_statements.headers.expire_date')
                };

                await this.$http
                .post(route("EstadoCuenta/getEstadosCuentaClientePDF"), payload)
                .then(
                    async response => {
                        if (response.body.code === 200){
                            this.report_url = response.body.ruta
                            //console.log(this.report_url) 
                            window.open(this.report_url, "_blank");  
                        }
                        else {
                            this.notifyMessage("danger", this.$t("app.promps.error"));
                        }
                    },
                    error => {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                )
                .finally(() => {});

                this.$swal.close();
            }
    }
}
</script>